import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
// fallow-ignore-next-line circular-dependency -- co-located route modules import their parent layout route from routes.tsx, which imports this module back into the tree (same cycle as every migrated route).
import { workflowsListLayoutRoute } from 'src/routes';
import { allWorkflowRunsSearchSchema } from '../../workflows/workflowAllRunsSearch';

// The org-wide "All Runs" tab: a child of the (still centrally declared)
// `/workflows` list layout, so its real URL is `/workflows/runs`.
//
// TRANSITIONAL LOCATION — same constraint as the workflow Memories tab:
// `custom/tanstack-route-file-path` resolves a module's full path from its own
// declaration, and an imported parent stops the walk, so a route declaring
// `/runs` must live where `/runs` alone derives. Move under
// `src/pages/authenticated/workflows/` when that layout migrates.
export const Route = createRoute({
  getParentRoute: () => workflowsListLayoutRoute,
  path: '/runs',
  staticData: {
    app: {
      access: {
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Workflow }],
      },
    },
  },
  validateSearch: allWorkflowRunsSearchSchema,
  component: lazyRouteComponent(
    () => import('../../workflows/AllWorkflowRunsTab'),
    'AllWorkflowRunsTab',
  ),
  loader: () => ({ crumb: msg('All Runs', { context: 'page breadcrumb' }) }),
});
